const state = {
  gridContextMenuModal: false,
  gridContextMenuKey: "",
  gridContextMenuEvent: {}
};

const mutations = {
  setGridContextMenuModal: (state, payload) =>
    (state.gridContextMenuModal = payload),
  setGridContextMenuKey: (state, payload) =>
    (state.gridContextMenuKey = payload),
  setGridContextMenuEvent: (state, payload) =>
    (state.gridContextMenuEvent = payload)
};

const getters = {
  gridContextMenuModal: state => state.gridContextMenuModal,
  gridContextMenuKey: state => state.gridContextMenuKey,
  gridContextMenuEvent: state => state.gridContextMenuEvent
};

export default { state, mutations, getters };
